//Отображение времени при добавлении рецепта
import React from 'react';
import {InputCheckbox, Tooltip} from '../'
import {  hint} from '../../../constants/constants'
import { Popup } from '../../organisms'

export const  TimeInput = (props) => {
  const { id, label, min, placeholder, timeKey, unit, unitСhoice, time, active } = props.item 
  const [hours, setHours] = React.useState(unit[0])
  const [showEventList, setshowEventList] = React.useState(false)
  const eventRef = React.useRef()
 

  function handleChangeEvents(el) {
    props.handleEditUnit(el, timeKey)
    setshowEventList(false)
  }

  const showCloseEvents = () => {  
    setshowEventList(!showEventList)
  }
  React.useEffect(() => {
    const click = e => {
      if (showEventList && eventRef.current && !eventRef.current.contains(e.target) && !e.target.classList.contains('eventtoggle') ) {
        setshowEventList(false)
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [showEventList])  
  return (
    <>
      {props.index === 1 && <legend className="font20EB colorGrey">Дополнительно:</legend>}
      <div className="form__label_time font20Norm colorGrey">
        <div className='form__block_time'>
       <InputCheckbox
          checked={props.checkboxStates[timeKey]}
          title={label}
          name={timeKey}
          id={timeKey}
          onChange={props.handleCheckboxChange}
       /> 
      
        <label className='form__label_time_err'>
        <input
          type="number"
          id={timeKey}
          name={timeKey}
          min='1' 
          placeholder='0'
          value={time}
          disabled={!props.checkboxStates[timeKey]}
          className={`form__input_time ${!props.checkboxStates[timeKey] ? 'input__disabled' : ''} ${props.error[timeKey] && props.checkboxStates[timeKey] ? 'form__input_error' : ''}`}
          onChange={props.handleTimeChange}
        /> 
        <Time
          onClick={handleChangeEvents}
          hours={hours}
          unit={unit}
          showCloseEvents={showCloseEvents}
          showEventList={showEventList}
          eventRef={eventRef}
          unitСhoice={unitСhoice}
        />
        </label>
       
         </div>
         {props.error[timeKey] && 
          (timeKey !== 'basic' ? props.checkboxStates[timeKey] : true) && 
            <span className="form__text_error font14Norm">
             {props.error[timeKey]}
            </span>
          }
      </div>
    </>
  );
    }


    const Time = (props) => {
      return(
        <div className='hours__select'>
          <div className='hours__select_visible  '>
            <p className='hours__unit' onClick={props.showCloseEvents} >{props.unitСhoice}</p>
           
        </div>
        <Popup isOpen={props.showEventList} ref={props.eventRef} type='hours' >
          {props.unit.map((el, index) => <span  key={index} className="form__span_time font20Norm colorGrey" onClick={()=> props.onClick(el)}>{el}</span>)}
        </Popup> 
      </div>
      )
    }